export default "__VITE_ASSET__7f910acb__"